<!-- Progress bar -->
<mat-progress-bar mode="indeterminate" *ngIf="status === 'Pending'"></mat-progress-bar>

<div class="p-4">
    <div>
        <!-- Header -->
        <div class="row">
            <div class="col-12">
                <h2>
                    <!-- Change profile picture -->
                    {{ 'SELF_SERVICE.DASHBOARD.CHANGE_AVATAR_DIALOG.TITLE' | translate }}
                </h2>
                <!-- Change your profile picture here. -->
                <p>{{ 'SELF_SERVICE.DASHBOARD.CHANGE_AVATAR_DIALOG.DESCRIPTION' | translate }}</p>
            </div>
        </div>
        <!--   Body   -->
        <div class="row pb-2" type="file" appDragAndDrop (fileDropped)="fileChangeEvent($event)">
            <div class="col-12 d-flex justify-content-center">
                <ng-container *ngIf="!imageChangedEvent || status === 'Error'">
                    <div class="image-container">
                        <img
                            [src]="data?.avatar ? data.avatar : '../../../../../../assets/img/self-service/avatar.svg'"
                            alt=""
                            class="avatar"
                        />
                        <div class="middle d-xl-block d-none">
                            <ng-template [ngTemplateOutlet]="AvatarActions"></ng-template>
                        </div>
                    </div>
                </ng-container>
                <div class="cropper-container" *ngIf="imageChangedEvent && status !== 'Error'">
                    <image-cropper
                        [imageChangedEvent]="imageChangedEvent"
                        [maintainAspectRatio]="true"
                        format="jpeg"
                        (imageCropped)="imageCropped($event)"
                        (loadImageFailed)="loadImageFailed()"
                        roundCropper="true"
                        resizeToWidth="250"
                        resizeToHeight="250"
                    ></image-cropper>
                </div>
            </div>

            <!-- Mobile Avatar Actions -->
            <div
                class="col d-flex justify-content-center d-xl-none px-2 pt-2"
                *ngIf="!imageChangedEvent || status === 'Error'"
            >
                <div class="flex-column d-flex">
                    <ng-template [ngTemplateOutlet]="AvatarActions"></ng-template>
                </div>
            </div>
        </div>
    </div>

    <!-- Error -->
    <div class="row" *ngIf="status === 'Error'">
        <div class="col d-flex justify-content-center" *ngIf="status === 'Error'">
            <p class="color-red">
                {{ errorDescriptionKey | translate }}
            </p>
        </div>
    </div>

    <!-- Dialog Actions -->
    <div class="row m-0">
        <div class="col-12 p-0 d-flex justify-content-end">
            <button mat-button color="primary" (click)="closeDialog()">
                <!-- Cancel -->
                {{ 'SELF_SERVICE.DASHBOARD.CHANGE_AVATAR_DIALOG.CANCEL.TITLE' | translate }}
            </button>
            <button
                mat-raised-button
                color="primary"
                class="ms-3"
                (click)="saveAvatar()"
                [disabled]="status !== 'Default' || !imageChangedEvent"
            >
                <!-- Change -->
                {{ 'SELF_SERVICE.DASHBOARD.CHANGE_AVATAR_DIALOG.CHANGE.TITLE' | translate }}
            </button>
        </div>
    </div>
</div>

<ng-template #AvatarActions>
    <button mat-flat-button color="primary" (click)="fileInput.click()" class="mb-1">
        <!-- Upload profile picture -->
        {{ 'SELF_SERVICE.DASHBOARD.CHANGE_AVATAR_DIALOG.UPLOAD.TITLE' | translate }}
    </button>
    <input
        hidden
        (change)="fileChangeEvent($event)"
        #fileInput
        (click)="fileInput.value = null"
        type="file"
        [accept]="['.jpg', '.jpeg', '.png']"
    />

    <button mat-button (click)="deleteAvatar()" *ngIf="data.avatar">
        <!-- Delete profile picture -->
        {{ 'SELF_SERVICE.DASHBOARD.CHANGE_AVATAR_DIALOG.DELETE.TITLE' | translate }}
    </button>
</ng-template>
